import * as jsxRuntime from "/home/idra/actions-runner/idrapoll-news-fe/_work/idrapoll-news-fe/idrapoll-news-fe/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment